import { GROUPS, PREFIX } from '@/service/apiConf';
import { get, postForm, postJSON, putJSON } from '@/service/request';

export const loginUrlMap = {
  kubesphereLogin: `${PREFIX.oauth}/kubesphere`,
  login: `${PREFIX.oauth}/login`,
  loginLDAP: `${PREFIX.oauth}/ldap`,
  getLoginType: `${PREFIX.oauth}/loginconfig`,
  getMenuConfig: `${PREFIX.oauth}/kv/MODULES`,
  createMenuConfig: `${PREFIX.vapis(GROUPS.confcenter)}/kv`,
  updateMenuConfig: `${PREFIX.vapis(GROUPS.confcenter)}/kv/MODULES`,
  register: `${PREFIX.oauth}/register`,
  registerphone: `${PREFIX.oauth}/registerphone`,
  registeremail: `${PREFIX.oauth}/registeremail`,
  sendsmscode: `${PREFIX.oauth}/sendsmscode`,
  sendemailcode: `${PREFIX.oauth}/sendemailcode`,
};

export function kubesphereLogin(data) {
  return postForm(`${loginUrlMap.kubesphereLogin}`, data);
}

export function login(data) {
  return postForm(`${loginUrlMap.login}`, data);
}

export function loginLDAP(data) {
  return postForm(`${loginUrlMap.loginLDAP}`, data);
}

export function getLoginType(data?): Promise<any> {
  return get(`${loginUrlMap.getLoginType}`, data);
}

export function getMenuConfig(): Promise<any> {
  return get(`${loginUrlMap.getMenuConfig}`, null, { flag: true });
}

export function createMenuConfig(data): Promise<any> {
  return postJSON(`${loginUrlMap.createMenuConfig}`, { key: 'MODULES', value: data.value });
}

export function updateMenuConfig(data): Promise<any> {
  return putJSON(`${loginUrlMap.updateMenuConfig}`, { key: 'MODULES', value: data.value });
}

export function register(data: { name: string; email: string; password: string; phone?: string }): Promise<any> {
  return postForm(`${loginUrlMap.register}`, data);
}

// 发送短信验证码
export function sendSmsCode(data: { phone: string }): Promise<any> {
  return postJSON(`${loginUrlMap.sendsmscode}?phone=${data.phone}`, {});
}

export function sendEmailCode(data: { email: string }): Promise<any> {
  return postJSON(`${loginUrlMap.sendemailcode}?email=${data.email}`, {});
}

/** 手机号注册，昵称与用户管理统一使用 displayName。 */
export function registerPhone(data: {
  phone: string;
  code: string;
  codesecret: string;
  password: string;
  displayName?: string;
}): Promise<any> {
  return postForm(`${loginUrlMap.registerphone}`, data);
}

/** 邮箱注册，昵称与用户管理统一使用 displayName。 */
export function registerEmail(data: {
  email: string;
  code: string;
  codesecret: string;
  password: string;
  displayName?: string;
}): Promise<any> {
  return postForm(`${loginUrlMap.registeremail}`, data);
}
